module.exports = __webpack_public_path__ + "img/sr_get.f0aa81b.png";